module.exports = __webpack_public_path__ + "static/vector-shape8-11c005eea6f514024644b33f4849eb92.png";